var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 90.625H96.875V96.875H3.125V90.625ZM17.1875 37.5C15.9443 37.5 14.752 37.9939 13.8729 38.873C12.9939 39.7521 12.5 40.9443 12.5 42.1875V84.375H31.25V42.1875C31.25 40.9443 30.7561 39.7521 29.8771 38.873C28.998 37.9939 27.8057 37.5 26.5625 37.5H17.1875ZM45.3125 62.5C44.0693 62.5 42.877 62.9939 41.9979 63.873C41.1189 64.7521 40.625 65.9443 40.625 67.1875V84.375H59.375V67.1875C59.375 65.9443 58.8811 64.7521 58.0021 63.873C57.123 62.9939 55.9307 62.5 54.6875 62.5H45.3125ZM73.4375 71.875C72.1943 71.875 71.002 72.3689 70.1229 73.248C69.2439 74.1271 68.75 75.3193 68.75 76.5625V84.375H87.5V76.5625C87.5 75.3193 87.0061 74.1271 86.1271 73.248C85.248 72.3689 84.0557 71.875 82.8125 71.875H73.4375ZM41.5625 44C42.6012 47.4567 44.4898 50.5978 47.0555 53.1363C49.6213 55.6748 52.7825 57.5296 56.25 58.5313C58.2857 59.0936 60.3881 59.3774 62.5 59.375C68.3016 59.375 73.8656 57.0704 77.968 52.968C82.0703 48.8656 84.375 43.3017 84.375 37.5C84.375 36.6712 84.0458 35.8764 83.4597 35.2903C82.8737 34.7043 82.0788 34.375 81.25 34.375H70.3125C69.0693 34.375 67.877 33.8812 66.9979 33.0021C66.1189 32.123 65.625 30.9307 65.625 29.6875V18.75C65.625 17.9212 65.2958 17.1264 64.7097 16.5403C64.1237 15.9543 63.3288 15.625 62.5 15.625C59.2373 15.6186 56.0144 16.3421 53.0675 17.7426C50.1206 19.143 47.5243 21.185 45.4688 23.7188C43.2171 26.5267 41.6845 29.8414 41.0038 33.3756C40.3231 36.9098 40.5149 40.5567 41.5625 44Z",
    fill: "url(#paint0_linear_4_33343)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28.125H93.75C94.5788 28.125 95.3737 27.7958 95.9597 27.2097C96.5458 26.6237 96.875 25.8288 96.875 25C96.875 19.1984 94.5703 13.6344 90.468 9.53204C86.3656 5.42968 80.8016 3.125 75 3.125C74.1712 3.125 73.3763 3.45424 72.7903 4.04029C72.2042 4.62634 71.875 5.4212 71.875 6.25V23.4688C71.875 26.7188 73.2812 28.125 75 28.125ZM3.125 3.125H46.875V9.375H3.125V3.125ZM3.125 15.625H31.25V21.875H3.125V15.625Z",
    fill: "url(#paint1_linear_4_33343)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_33343",
    x1: -0.976561,
    y1: 17.3177,
    x2: 102.735,
    y2: 124.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_33343",
    x1: -0.976561,
    y1: 3.64583,
    x2: 16.4596,
    y2: 62.3265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalytics);
export default __webpack_public_path__ + "static/media/Data-Analytics.d233f66a0ebb44dc86cebe80a896c766.svg";
export { ForwardRef as ReactComponent };